var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPencil = function SvgPencil(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.42 11.26c.78.78.78 2.04 0 2.82l-3.66 3.66-7.5-7.5 3.66-3.66a1.99 1.99 0 0 1 2.82 0zM6 34.5V42h7.5l22.12-22.12-7.5-7.5zm26.085-14.62L12.464 39.5H8.5v-3.964l19.62-19.62z"
  })));
};
export default SvgPencil;